import { Box } from "@mui/material";

interface OptionItem {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Pass an array with 2+ items to render an N-way toggle. */
  items?: OptionItem[];
  /** Legacy 2-option shorthand — ignored when `items` is provided. */
  options?: {
    left: OptionItem;
    right: OptionItem;
  };
}

const itemStyle = (selected: boolean, disabled: boolean) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  backgroundColor: selected ? "primary.main" : "transparent",
  color: selected ? "white" : "primary.main",
  fontSize: "0.75rem",
  fontWeight: "medium",
  textTransform: "uppercase",
  transition: "all 0.2s ease",
  cursor: disabled ? "not-allowed" : "pointer",
  userSelect: "none",
  "&:hover": {
    backgroundColor: selected ? "primary.dark" : "rgba(25, 118, 210, 0.08)",
    color: selected ? "white" : "primary.main",
  },
});

const TypeToggleButton = ({
  value,
  onChange,
  disabled = false,
  items,
  options = {
    left: { value: "util", label: "Util" },
    right: { value: "fixo", label: "Fixo" },
  },
}: Props) => {
  const resolvedItems: OptionItem[] = items ?? [options.left, options.right];

  return (
    <Box
      sx={{
        display: "flex",
        borderRadius: "7px",
        border: "1px solid",
        borderColor: "primary.main",
        overflow: "hidden",
        opacity: disabled ? 0.6 : 1,
        height: "40px",
        width: "100%",
      }}
    >
      {resolvedItems.map((item, index) => (
        <Box
          key={item.value}
          sx={{
            ...itemStyle(value === item.value, disabled),
            borderLeft: index > 0 ? "1px solid" : "none",
            borderColor: "primary.main",
          }}
          onClick={() => !disabled && onChange(item.value)}
        >
          {item.label}
        </Box>
      ))}
    </Box>
  );
};

export default TypeToggleButton;
